<div class="app-wrapper" [ngClass]="{ 'no-scroll': isLoading }">
    <!-- || (isOnline!=null && !isOnline) -->
    <div class="route-animator" [@pageAnim]="prepareRoute(outlet)">
        <router-outlet #outlet="outlet"></router-outlet>
    </div>
    <!-- || (isOnline!=null && !isOnline) -->
    <div *ngIf="isLoading" class="loading"></div>
    <!-- <div *ngIf="isOnline!=null" class="online-status" [ngClass]="{'online':isOnline,'offline':!isOnline}">{{isOnline?'Online':'offline'}}</div> -->
</div>